// ============================================================================
// CMS Page Builder — Editor Block Context
// Provides editor callbacks to nested block renderers (columns, tabs children)
// so they can participate in click-to-select, hover outlines, inline editing, etc.
// ============================================================================

import { createContext, useContext } from 'react';
import type { EditorSelection } from '../editor/types';

export interface EditorBlockContextValue {
  /** True only when rendered inside the editor canvas (not preview pane) */
  isEditorCanvas?: boolean;
  sectionId: number;
  onSelectBlock: (sectionId: number, blockId: string) => void;
  selection: EditorSelection | null;
  resolvedImageMap: Record<number, { image_id: number; data: Record<string, string>; alt: string; error?: string }>;
  onCropImage?: (imageId: number, imageUrl: string) => void;
  /** Callback to update block props from inline editing */
  onBlockPropsChange?: (sectionId: number, blockId: string, props: Record<string, unknown>) => void;
  /** Block ID currently in inline edit mode (only one at a time) */
  editingBlockId: string | null;
  /** Enter or exit inline edit mode for a block */
  setEditingBlock: (blockId: string | null) => void;
}

const EditorBlockContext = createContext<EditorBlockContextValue | null>(null);

export const EditorBlockContextProvider = EditorBlockContext.Provider;

export function useEditorBlockContext(): EditorBlockContextValue | null {
  return useContext(EditorBlockContext);
}
